module.exports = __webpack_public_path__ + "img/horizontal_6_1_9016.73421816.png";